export const removeEmptyObjects = <T extends Record<string, unknown | Array<unknown>>>(obj: T): T => {
  Object.keys(obj).forEach((key) => isEmptyObject(obj[key]) && delete obj[key]);
  return obj;
};

const isEmptyObject = (object: unknown): boolean => JSON.stringify(object) === "{}";
